document.querySelectorAll('.mega-menu').forEach(function (megaMenu) {
  const image = megaMenu.querySelector('[data-mega-menu-preview-image]');
  if (!image) return;

  const defaultSrc = image.dataset.defaultImage;
  const links = megaMenu.querySelectorAll('[data-preview-image]');

  links.forEach(function (link) {
    const showPreview = function () {
      image.src = link.dataset.previewImage;
    };
    link.addEventListener('mouseenter', showPreview);
    link.addEventListener('focus', showPreview);
  });

  megaMenu.addEventListener('toggle', function () {
    if (megaMenu.hasAttribute('open')) {
      image.src = defaultSrc;
    }
  });
});
